import {
  completeMaterialsWorkshopInvestigation,
  discoverMaterialsWorkshop,
  getMaterialsInvestigationSnapshot,
  isMaterialsWorkshopRouteAvailable,
  persistMaterialsInvestigationSnapshot,
} from '../DiscoveryLabState.js';
import { MaterialsInvestigation } from '../minigames/materials/MaterialsInvestigation.js';
import { MATERIALS_WORKSHOP_PRODUCTION_READY } from './MaterialsWorkshopAssets.js';
import { MATERIALS_WORKSHOP_ROOF_1 } from './MaterialsWorkshopConfig.js';

/** Art-gated progression adapter for the first Materials Workshop configuration. */
export function enterMaterialsWorkshopInvestigation() {
  if (!MATERIALS_WORKSHOP_PRODUCTION_READY || !isMaterialsWorkshopRouteAvailable()) {
    return { available: false as const, reason: 'production-art-gated' as const };
  }

  const discovery = discoverMaterialsWorkshop();
  if (!discovery.unlocked) {
    return { available: false as const, reason: 'route-unavailable' as const };
  }
  const savedSnapshot = getMaterialsInvestigationSnapshot(MATERIALS_WORKSHOP_ROOF_1.id);
  const investigation = new MaterialsInvestigation(
    MATERIALS_WORKSHOP_ROOF_1,
    {
      onStateChanged: snapshot => { persistMaterialsInvestigationSnapshot(snapshot); },
      onCompleted: (_result, _config, snapshot) => {
        completeMaterialsWorkshopInvestigation(snapshot);
      },
    },
    savedSnapshot,
  );
  persistMaterialsInvestigationSnapshot(investigation.getSnapshot());
  return {
    available: true as const,
    newlyDiscovered: discovery.newlyDiscovered,
    investigation,
  };
}
